import { userConstants } from './constantData';

export const SEARCH_DATA = {
  search_default_screen: {
    clear_search: {
      hash: 'e-008.036.001.000.000.040',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_search_terms', /* 26 */
      ],
    },
    default_content: {
      hash: 'e-008.036.001.000.000.220',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_search_terms', /* 26 */
        'v_list_position', /* 32 */
        'v_provider_name', /* 35 */
        'v_collection_name', /* 36 */
      ],
    },
  },
  search_result: {
    clear_search: {
      hash: 'e-008.036.001.000.000.040',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_search_terms', /* 26 */
      ],
    },
    related_search_result: {
      hash: 'e-008.036.001.000.000.112',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_search_terms', /* 26 */
        'v_content_name', /* 17 */
        'v_content_type', /* 18 */
        'v_content_id', /* 19 */
        'v_genre', /* 20 */
        'v_play_source', /* 21 */
        'v_section_name', /* 31 */
        'v_list_position', /* 32 */
        'v_transmission_type', /* 34 */
        'v_content_locked', /* 37 */
        'v_channel_id', /* 50 */
        'v_content_player_type', /* 53 */
        'v_is_sports', /* 66 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
        'v_is_betting', /* 81 */
        'v_video_duration', /* 100 */
      ],
    },
  },
  search_not_found: {
    related_search_result_not_found: {
      hash: 'e-008.036.001.000.000.042',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_search_terms', /* 26 */
      ],
    },
  },
};
